export default {
  appName: 'Minday ',
  appDesc: 'Thank you for using the services provided by Minday!',
  authorizationTableiOS01: 'iOS 14.5 and above, allow app tracking',
  authorizationTableiOS02: 'Used to provide personalized advertising',
  authorizationTableAndroid01: 'Allow applications to access the Internet',
  authorizationTableAndroid02: 'Used to obtain business data from the server',
  authorizationTableAndroid03: 'Allow the application to stay awake',
  authorizationTableAndroid04: 'Used to prevent the application from sleeping',
  companyName: 'Sanhe Zhishi Technology Co., Ltd.',
  contactEmail: "support{'@'}ifyyy.cn",
};
